import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import React from 'react';
const {
  Text
} = _Typography;
export function TextEllipsis({
  value,
  copyable = false,
  ellipsis = {
    showTooltip: true
  }
}) {
  if (!value) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Text, {
    style: {
      marginBottom: 0
    },
    copyable: copyable,
    ellipsis: ellipsis
  }, value);
}